import React from 'react';
import { Popover, Dropdown}from 'react-bootstrap';
import {
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
} from 'reactstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import './announcements.css';
import { 
    getAnnouncements,
    updateUserProfile,
    saveUserProfile,
    fetchUserProfile
} from "../../actions";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin, appInsights } from "../../AppInsights";
import { connect } from "react-redux";
import greenTick from '../../../src/assets/green-tick.svg';
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from 'react-toastify';
import _ from "lodash";


const initialState = {
    announce_status: false,
    show: false,
    target: null,
    isRefreshModalOpen: false,
    description: "",
    newUser: true,
}
let user;

class Announcements extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ...initialState,
        }
        if (localStorage.getItem("auth_token")) {
            user = jwt_decode(localStorage.getItem("auth_token"));
        }
    }

    async componentDidMount(){
        this.checkAnnouncements();
        this.schedule = setInterval(()=> this.checkAnnouncements(), 10*60*1000);

        // To set the highest announcment ID in localStorage
        this.setMaxId()

        await this.props.fetchUserProfile().then((response) => {
            if ((this.props.userProfile.length > 0)) {
                if (this.props.userProfile[0]['announcements_data']) {
                    this.setState({
                        announcementStatus: this.props.userProfile[0]['announcements_data']
                    })
                    this.setState({ newUser: false })
                }
            }
        });
    }

    componentWillUnmount() {
        clearInterval(this.schedule);
        this.schedule = null;
    }

    setMaxId(){
        let persist_root = localStorage.getItem('persist:root')
        if (!persist_root) return; // Guard: exit if persist_root doesn't exist
        
        try {
            var root = JSON.parse(persist_root);
            if(root && root.announcements_data){
                var announcements_data = JSON.parse(root.announcements_data)
                if (announcements_data && announcements_data.announcementsList) {
                    announcements_data = announcements_data.announcementsList
                    let i=0
                    let announcement_ids=[]
                    for(i=0;i<announcements_data.length;i++){
                        announcement_ids.push(parseInt(announcements_data[i]['announcement_id']))
                    }
                    let max_id
                    max_id = Math.max(...announcement_ids)
                    if(!localStorage.getItem('announced_id') || localStorage.getItem('announced_id').includes('-Infinity')){
                        localStorage.setItem('announced_id',max_id)
                    }
                }
            }
        } catch (e) {
            console.warn('Error parsing announcements data:', e);
        }
    }
    
    saveAnnouncementStatus() {
        if(this.props.userProfile.length===0){
            let data = {
                'email_id': user.unique_name,
                announcements_data:{
                    'upgrade':true,
                    'announcement_id':this.state.announce_id
                }
            }
            this.props.saveUserProfile(data).then((response) => {
                let message = "Upgraded completed successfully!";
                toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
        }
        else{
            let data = {
                id: this.props.userProfile[0].id,
                email_id: user.unique_name,
                announcements_data:{
                    'upgrade':true,
                    'announcement_id':this.state.announce_id
                }
            }
            this.props.updateUserProfile(data).then((response) => {
                let message = "Upgraded completed successfully!";
                toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
        }
    }

    async checkAnnouncements() {
        this.setMaxId()
        await this.props.getAnnouncements({created_at_gte:moment().subtract(2,'d').format('YYYY-MM-DD')});
        let announcements_session = JSON.parse(sessionStorage.getItem('announcements_session'));
        if (announcements_session){
            let checker = (arr, target) => target.every(v => arr.some(item => item.announcement_id === v.announcement_id));
            if (!checker(announcements_session, this.props.announcementsList)){
                this.setState({ announce_status: true }, this.handleSync);
            }
            else{
                this.setState({ announce_status: false }, this.handleSync);
            }
        }
        else if (this.props.announcementsList.length != 0)
            this.setState({ announce_status: true }, this.handleSync);
        else
            this.setState({ announce_status: false }, this.handleSync);        
    }

    handleSync = () => {
        sessionStorage.setItem('announce_session_status', this.state.announce_status);    
        this.props.handleChange(this.state.announce_status);
        this.props.handleAnnouncements(this.props.announcementsList);
    }

    handleClick = (event) => {
        this.setState({
            show: !(this.state.show),
            target: event.target,
        })
    }
    
    handlePopup = (event, des, id) => {
        this.setState({
            announce_id: id 
        })
        if(this.state.announcementStatus){
            if(id > this.state.announcementStatus.announcement_id && localStorage.getItem('announced_id') < id && !localStorage.getItem('announced_id').includes('-Infinity')){  
                this.setState({
                    isRefreshModalOpen: !(this.state.isRefreshModalOpen),
                    description: des,
                })
            }
        }
        else{
            this.setState({
                isRefreshModalOpen: !(this.state.isRefreshModalOpen),
                description: des,
            })
        }
    }
    
    handleRefresh = () =>
        this.setState({ isRefreshModalOpen: !this.state.isRefreshModalOpen });

    refreshPage = () => {
        this.saveAnnouncementStatus()
        window.location.reload();
    }

    hide = () => {
        this.setState({
            show: false,
        })
    }
    handleLink = (message) => {
        this.props.setSearchFilterword(String(message))
        this.props.setWikiSidebar(true)
    }

    reverseArray = (array) =>{
        var ret = new Array;
        for(var i = array.length-1; i >= 0; i--) {
            ret.push(array[i]);
        }
        return ret;
    }

    render(){
        return (
            <>
                <div>
                    <div className={this.props.announcementsList?
                     'announcements show-new' : 'announcements'}
                        data-count='' onClick={event => this.handleClick(event)}><FontAwesomeIcon icon={faBullhorn} className='fa-1x demo-icon' ></FontAwesomeIcon> Announcements
                    </div>
                </div>
                <Dropdown ref={this.ref}>
                    {/* <Dropdown.Toggle
                        show={this.state.show}
                        target={this.state.target}
                        placement="bottom"
                        container={this.ref}
                        containerPadding={20}
                        rootClose={true}
                        onHide={this.hide}
                    >
                    </Dropdown.Toggle> */}
                    <Dropdown.Item id="popover-contained">
                        <Popover.Content className='notification-padding announcements-padding'>
                            <ul className="announcements-info-panel">
                                {
                                    this.props.announcementsList?
                                    
                                    this.reverseArray(this.props.announcementsList).map((message, index) =>
                                        <li
                                        onClick={(event)=>{this.hide()}}
                                        className='announcements-message'
                                        key={index}
                                        >
                                            {['release','upgrade'].some(substring=>message['title'].toLowerCase().includes(substring))?
                                            <span 
                                            onClick={(event) => this.handlePopup(event, message['description'], message['announcement_id'])}>                      
                                                <div className="message-title">
                                                    {message['title']}
                                                    {this.state.announcementStatus ? 
                                                        localStorage.getItem('announced_id').includes('-Infinity')?
                                                            <img
                                                                className="header-img green-tick"
                                                                src={greenTick}
                                                                width="15"
                                                                data-tut="reactour__dashboard"
                                                                alt=""
                                                            />
                                                        :
                                                        this.state.announcementStatus.announcement_id >= message['announcement_id'] || localStorage.getItem('announced_id') >= message['announcement_id']?
                                                            this.state.announcementStatus.upgrade===true?
                                                            <img
                                                                className="header-img green-tick"
                                                                src={greenTick}
                                                                width="15"
                                                                data-tut="reactour__dashboard"
                                                                alt=""
                                                            />
                                                            :null
                                                        :null
                                                    :null}
                                                </div>
                                                <div className="message">
                                                    {this.state.announcementStatus ? 
                                                        localStorage.getItem('announced_id').includes('-Infinity')?
                                                            <li>Update already done! You have our latest version.</li>
                                                        :
                                                        this.state.announcementStatus.announcement_id >= message['announcement_id'] || localStorage.getItem('announced_id') >= message['announcement_id']?
                                                            this.state.announcementStatus.upgrade===true?
                                                                <li>Update already done! You have our latest version.</li>
                                                            :
                                                                <li><a href=" ">Click here</a> to continue update</li>
                                                        :
                                                            <li><a href=" ">Click here</a> to continue update</li>
                                                    :<li><a href=" ">Click here</a> to continue update</li>        
                                                    }
                                                </div>
                                            </span>:
                                            <span>
                                                <div className="message-title">
                                                New wiki article {message['title']}
                                                </div>
                                                <div className="message-normal" >
                                                by <li className="message-title" >{message['description']}</li> is available
                                                </div>
                                                <div><li className="message description"  onClick={(event)=>this.handleLink(message['wiki_refid'])} >Click here</li><li className="message" > to open</li></div>
                                            </span>
                                            }
                                        </li>
                                    ) :
                                    <div className="center-icon">
                                        <FontAwesomeIcon className="fa-2x" color={'#364db2'} icon={faExclamationTriangle}></FontAwesomeIcon>
                                        <h5 className="nodata">No new announcements found!</h5>
                                    </div>
                                }
                            </ul>
                        </Popover.Content>
                    </Dropdown.Item>
                </Dropdown>
                <Modal isOpen={this.state.isRefreshModalOpen} toggle={this.handleRefresh}>
                    <ModalHeader toggle={this.toggleDeleteModal} className="edit-popup announcements-title">
                        <FontAwesomeIcon className="announcement-icon" icon={faBullhorn}/>
                        Upgrade to the Latest Version
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        <p>Dear User,</p>
                        <p>{this.state.description}</p>
                        <div className= "edit-popup-message"><span className="required-icon">Warning: </span>
                                All unsaved work will be lost.
                        </div>
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                        <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.handleRefresh}>Ignore</Button>
                        <Button id="deleteButton" className="custom-button upgrade-button" onClick={this.refreshPage}>Upgrade</Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
      announcementsList: state.announcements_data.announcementsList,
      userProfile: state.dashboard_data.userProfile
    };
  };
export default withAITracking(
    reactPlugin,
    connect(mapStateToProps, {
      getAnnouncements,
      updateUserProfile,
      saveUserProfile,
      fetchUserProfile,
    })(Announcements),
    "Announcements",
    "Announcements"
  );